import { HelpOutlineOutlined as ErrorIcon } from '@mui/icons-material';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { useIntl } from 'react-intl';

const IconWrapper = styled('figure')(
  ({ theme }) => ({
    margin: 0,
    width: 32,
    height: 32,
    backgroundColor: `rgba(0, 0, 0, ${theme.isDark ? '0.3' : '0.05'})`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '.MuiSvgIcon-root': {
      width: 20,
      height: 20,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: 'transparent',
    borderRight: `2px solid ${theme.palette.divider}`,
  })),
);

const ImagePreviewErrorState = () => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatMessage({
        id: 'portfolio.challenge.files.uploaded_image.error_state.messages.no_longer_available',
      })}
    >
      <IconWrapper>
        <ErrorIcon />
      </IconWrapper>
    </Tooltip>
  );
};

export default ImagePreviewErrorState;
